var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 119,
    viewBox: "0 0 115 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7131 28.8907C21.4222 25.5049 26.9974 22.9203 34.4389 21.137C41.722 19.3917 49.0988 19.4343 56.5692 21.2646C63.881 23.1328 70.4837 26.2323 76.3767 30.5627C88.6941 39.3463 96.5366 50.7629 99.9034 64.8124C103.157 78.3898 100.792 89.1313 92.8087 97.037C88.3194 101.359 82.5125 104.373 75.3878 106.081C61.2964 109.458 47.5011 107.083 34.0017 98.9573C20.5023 90.8315 11.9702 79.3306 8.40523 64.4544C4.81202 49.4602 7.9147 37.6059 17.7131 28.8907Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8624 8.87695C55.1082 8.87695 53.5186 9.91003 52.8061 11.513L38.1949 44.3883H30.2511C23.0532 44.2846 17.3961 50.1049 16.5088 56.6647C16.4821 56.8619 16.4688 57.0607 16.4688 57.2597V85.2245C16.4688 85.4235 16.4821 85.6223 16.5088 85.8195C17.4361 92.6751 23.3387 97.7542 30.2514 97.6534H40.7915C40.8218 97.654 40.8521 97.6543 40.8825 97.6543H87.2822C93.4653 97.7104 98.7508 93.211 99.6818 87.0963L105.195 51.1419L105.196 51.1352C105.743 47.5298 104.679 43.8664 102.287 41.1146C99.9 38.3699 96.4309 36.8086 92.7947 36.8418H73.2862V25.3008C73.2862 16.2301 65.933 8.87695 56.8624 8.87695ZM45.3214 88.7765H87.3544C89.125 88.7966 90.6399 87.5092 90.9055 85.7583L90.9065 85.7512L96.4186 49.803C96.5737 48.7742 96.2703 47.7254 95.5872 46.9398C94.9038 46.1538 93.9092 45.7074 92.8677 45.7193L92.8173 45.7198L68.8474 45.7195C66.3959 45.7195 64.4085 43.7322 64.4085 41.2807V25.3008C64.4085 22.0728 62.3817 19.3183 59.5313 18.2402L45.3214 50.2126V88.7765Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/ThumbsUpIcon.59b2c7a230825e09f22b285778a44a9e.svg";
export { ForwardRef as ReactComponent };